import { Table } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(({ palette, ...theme }) => ({}));

function MatxTable(props) {
  const classes = useStyles();
  return <Table className={classes.table}>{props.children}</Table>;
}

export default MatxTable;
